import { extend, localize } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import * as rules from "vee-validate/dist/rules";
import de from "vee-validate/dist/locale/de.json";
import en from "vee-validate/dist/locale/en.json";
import i18n from "../i18n";

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

const validationMessages = {
  en: en.messages,
  de: de.messages,
};

// Extend the custom rule for both languages
extend("selected", {
  validate: (value) => parseInt(value) !== 0,
  message: (fieldName) =>
    `${fieldName} ${i18n.t("ratingForm.validation.required")}`,
});

extend("required", {
  ...required,
  message: (fieldname) =>
    `${i18n.t(`ratingForm.validation.fields.${fieldname}`)} ${i18n.t(
      "ratingForm.validation.required"
    )}`,
});

export const updateValidationMessages = (locale) => {
  localize(locale, {
    messages: validationMessages[locale],
  });
};
